import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\CreateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/CreateTemplateDashboardController.php
* @route '/api/template-dashboard'
*/
const CreateTemplateDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTemplateDashboardController.url(options),
    method: 'post',
})

CreateTemplateDashboardController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\CreateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/CreateTemplateDashboardController.php
* @route '/api/template-dashboard'
*/
CreateTemplateDashboardController.url = (options?: RouteQueryOptions) => {
    return CreateTemplateDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\CreateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/CreateTemplateDashboardController.php
* @route '/api/template-dashboard'
*/
CreateTemplateDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTemplateDashboardController.url(options),
    method: 'post',
})

export default CreateTemplateDashboardController